'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

import { useFormContext } from '@/components/forms/FormContext';
import { ReplaceVirtuallyFormActions } from '../ReplaceVirtuallyForm/reducer';

const HeatSyncHandler = () => {
	const { dispatch, state } = useFormContext();
	const searchParams = useSearchParams();

	useEffect(() => {
		// get the state from the query params
		const stateId = searchParams?.get('q');

		if (!stateId) {
			return;
		}

		fetch(`/api/store?q=${stateId}`)
			.then((res) => {
				if (!res.ok) {
					throw new Error('No State ID');
				}

				return res.json();
			})
			.then((stateId) => {
				const stateValue = JSON.parse(stateId.State);

				// So long as the cache is not hydrated and the state is in the query params
				// hydrate the context with the state from the query params
				if (state && stateValue) {
					dispatch({
						type: ReplaceVirtuallyFormActions.HYDRATE_STATE,
						payload: stateValue,
					});
				}
			})
			.catch((error) => {
				throw new Error('Failed to fetch state data: ' + error.message);
			});
	}, []);

	return null;
};

export default HeatSyncHandler;
